import React, {Component} from "react"

import id from "@irati/utils/id"
import UpdateInsWizard from "@irati/insights/apollo/client/mutation/InsWizard"
import {CustomQuestionCount} from "@irati-web/fields/schedule"
import GetDeletedQuestionGroup from "@irati/insights/apollo/query/wizard/DeletedQuestionGroup"


class CustomFrequencySection extends Component {
  render() {
    return (
      <UpdateInsWizard>
        {(_, {cycle, questions, updateCycle}) => {
          const idNamespace = id("CustomFrequencySection", this.props)
          return (
            <GetDeletedQuestionGroup>
              {({questionGroup: {uuid: deletedQuestionGroupUuid}}) => {
                return (
                  <div id={idNamespace}>
                    <CustomQuestionCount
                      id={idNamespace}
                      cycle={cycle}
                      onChange={updateCycle}
                      deletedQuestionGroupUuid={deletedQuestionGroupUuid}
                      questions={questions} />
                  </div>
                )
              }}
            </GetDeletedQuestionGroup>
          )
        }}
      </UpdateInsWizard>
    )
  }
}

export default CustomFrequencySection
